import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { counterReducer } from "./Slices/test.slice";
import { alertReducer } from "./Slices/alert.slice";
import { sideMenuReducer } from "./Slices/sideMenu.slice";
import { userReducer } from "./Slices/user.slice";
import { persistedRegisterParents } from "./Persist/persistedRegisterParent";
import { focusOnValidationReducer } from "./Slices/focusOnValidation.slice";
import { persistStudentAdmission } from "./Persist/persistAdmissionStudent";
import { persistedRegisterTeacher } from "./Persist/persistedRegisterTeacher";
import { studentResultReducer } from "./Slices/studentResuilt.slice";

const userPersistConfig = {
  key: "user",
  version: 1,
  storage,
  /*  transforms: [persistTransform], */
};

const persistedUserReducer = persistReducer<any, any>(
  userPersistConfig,
  userReducer
);
const store = configureStore({
  reducer: {
    counter: counterReducer,
    alert: alertReducer,
    sideMenu: sideMenuReducer,
    user: persistedUserReducer,
    registerParents: persistedRegisterParents,
    focusOnValidation: focusOnValidationReducer,
    studentAdmission: persistStudentAdmission,
    registerTeacher: persistedRegisterTeacher,
    studentResult: studentResultReducer,
  },
  /*   middleware: [thunk], */
});
export default store;
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
